import Prism from "prismjs";
if (typeof globalThis !== "undefined") globalThis.Prism = Prism;
